import * as React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import userRoutes from './components/routes/userRoutes';
import hrRoutes from './components/routes/hrRoutes';
import Authentication from './Pages/Authentication';
import adminRoutes from './components/routes/adminRoutes';
import { useSelector } from 'react-redux';
import { Toaster } from 'sonner';
import InstructorRoute from './components/routes/InstructorRoute';
import AnimatedError404 from './components/Error404';
import ForgotPassword from './Pages/ForgotPassword';
import ResetPassword from './Pages/ResetPassword';
import { RootState } from './types';

const RouterWrapper = () => {
  const { user } = useSelector((state: RootState) => state.user);
  const isAuthenticated = user
  const loginRoute = (
    <Routes>
      <Route path="/login" element={<Authentication />} />
      <Route path="/forgot-password" element={<ForgotPassword />}></Route>
      <Route path="/reset-password" element={<ResetPassword />}></Route>
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );

  const getRoutesForRole = (role: string) => {
    switch (role) {
      case 'hr':
        return hrRoutes();
      case 'admin':
        return adminRoutes();
      case 'student':
        return userRoutes();
      case 'instructor':
        return InstructorRoute();
      default:
        return (
          <Routes>
            <Route path="*" element={<AnimatedError404 />} />
          </Routes>
        );
    }
  };

  return (
    <BrowserRouter>
      {isAuthenticated ? getRoutesForRole(isAuthenticated.role) : loginRoute}
      <Toaster richColors />
    </BrowserRouter>
  );
};

export default function App() {
  return <RouterWrapper />;
}
